import { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl, clientheaderconfig } from "../components/Helpers/Config";
/* import { supabase } from "@/integrations/supabase/client"; */

export interface AuditRow {
  id: string;
  voucherID: {
    label: string;
    value: string;
  };
  name: string;
  color: string | null;
  configured: number; // %
  observed: number; // %
  wins: number;
  expected: number;
  ciLow: number; // %
  ciHigh: number; // %
  drift: number; // observed - configured (pts)
  status: "on-target" | "under" | "over";
}

export interface AuditSummary {
  totalSpins: number;
  activePrizes: number;
  significance: "very-low" | "low" | "moderate" | "high";
  rows: AuditRow[];
}

// Wilson score interval for binomial proportion
function wilson(successes: number, n: number, z = 1.96) {
  if (n === 0) return [0, 0];
  const p = successes / n;
  const denom = 1 + (z * z) / n;
  const center = (p + (z * z) / (2 * n)) / denom;
  const margin = (z * Math.sqrt((p * (1 - p)) / n + (z * z) / (4 * n * n))) / denom;
  return [Math.max(0, center - margin), Math.min(1, center + margin)];
}

export function useProbabilityAudit(orgId: string | undefined, prizeData:AuditRow, days: number) {
  console.log(prizeData,days,  'prizeDataprizeDataprizeData')
  const [data, setData] = useState<AuditSummary>({
    totalSpins: 0,
    activePrizes: 0,
    significance: "very-low",
    rows: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   /*  if (!orgId) { setLoading(false); return; } */
    let cancelled = false;
    (async () => {
      console.log('startttttttttttttttt')
      setLoading(true);
      const since = new Date();
      since.setDate(since.getDate() - days);

       const { data: results } = await axios.get(`${apiUrl}analytics?creditType=ScratchCard&spin_timestamp=${since}`, clientheaderconfig);
          const spinData = results?.result || [];

      const prizes =  (prizeData ?? []) as any[];
      const sessions = (spinData ?? []) as any[];
      console.log(prizes, sessions, 'sessionssessionssessionssessions')
      const totalSpins = sessions.length;
      const activePrizes = prizes.filter((p) => p.active).length;

      const counts: Record<string, number> = {};
      sessions.forEach((s) => {
        counts[s.prize_id] = (counts[s.prize_id] || 0) + 1;
      });

      const rows: AuditRow[] = prizes
        /* .filter((p) => p.active) */
        .map((p) => {
          console.log(p, 'sssssssssssssssss')
          const wins = counts[p.voucherID.value] || 0;
          const configured = Number(p.probability) || 0;
          const observed = totalSpins > 0 ? (wins / totalSpins) * 100 : 0;
          const expected = (configured / 100) * totalSpins;
          const [lo, hi] = wilson(wins, totalSpins);
          const drift = observed - configured;
          const ciLowPct = lo * 100;
          const ciHighPct = hi * 100;
          // status: on-target if configured falls within CI
          const status: AuditRow["status"] =
            configured >= ciLowPct && configured <= ciHighPct
              ? "on-target"
              : observed < configured
              ? "under"
              : "over";
          return {
            id: p.id,
            voucherID:p.voucherID,
            name: p.name,
            color: p.color,
            configured,
            observed,
            wins,
            expected,
            ciLow: ciLowPct,
            ciHigh: ciHighPct,
            drift,
            status,
          };
        });

      let significance: AuditSummary["significance"] = "very-low";
      if (totalSpins >= 1000) significance = "high";
      else if (totalSpins >= 300) significance = "moderate";
      else if (totalSpins >= 50) significance = "low";

      if (!cancelled) {
        setData({ totalSpins, activePrizes, significance, rows });
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [days]);

  return { data, loading };
}
